import { ProductDetail } from "../types/product";

export const PRODUCTS: ProductDetail[] = [
  {
    id: 1,
    name: "Burmese Ruby, Zambia Emerald, Yellow Sapphire",
    price: 1180,
    size: 7,
    specifications: [
      "Burmese Ruby",
      "Zambian Emerald",
      "Orange Sapphire",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-01.jpg?alt=media",
  },
  {
    id: 2,
    name: "Sky Blue Topaz",
    price: 380,
    size: 6.5,
    specifications: ["Sky Blue Topaz", "Silver 925"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-02.jpg?alt=media",
  },
  {
    id: 3,
    name: "Burmese Ruby, Unheated Opal",
    price: 1180,
    size: 7,
    specifications: [
      "Burmese Ruby",
      "Unheated Opal",
      "Blue Sapphire",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-03.jpg?alt=media",
  },
  {
    id: 4,
    name: "Burmese Ruby, Emerald, White Zircon",
    price: 590,
    size: 7.5,
    specifications: [
      "Burmese Ruby .33ct",
      "Emerald .20ct",
      "White Zircon",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-04.jpg?alt=media",
  },
  {
    id: 5,
    name: "Ruby, Sapphire",
    price: 1250,
    size: 9,
    specifications: [
      "Burmese Natural Ruby",
      "Comment: HT(A)",
      "Cut: Very Good",
      "Blue Sapphire",
      "Silver 925",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-05.jpg?alt=media",
  },
  {
    id: 6,
    name: "Pink Sapphire, Yellow Sapphire",
    price: 1140,
    size: 6,
    specifications: [
      "Padparadscha .97ct",
      "Yellow Sapphire 1.22ct",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-06.jpg?alt=media",
  },
  {
    id: 7,
    name: "Natural Green Emerald, Royal Blue Sapphire",
    price: 620,
    size: 7,
    specifications: [
      "Zambian Natural Emerald",
      "Srilankan Narutal Royal Blue Sapphire",
      "Comment: CEE(O) Minor / HT",
      "Cut: Very Good",
      "White Zircon",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-07.jpg?alt=media",
  },
  {
    id: 8,
    name: "Natural Star Ruby HT(A), Blue Sapphire",
    price: 1220,
    size: 7.5,
    specifications: [
      "Burmese Natural Star Ruby",
      "Comment: HT(A)",
      "Cut: Very Good",
      "Blue Sapphire",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-08.jpg?alt=media",
  },
  {
    id: 9,
    name: "Natural Star Ruby HT(A), Orange Sapphire",
    price: 1220,
    size: 7.5,
    specifications: [
      "Burmese Natural Star Ruby",
      "Comment: HT(A)",
      "Cut: Very Good",
      "Blue Sapphire",
      "Orange Sapphire",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-09.jpg?alt=media",
  },
  {
    id: 10,
    name: "Natural Royal Blue Sapphire, White Zircon",
    price: 850,
    size: 6.5,
    specifications: [
      "Srilankan Natural Blue Sapphire .50ct",
      "Comment: HT",
      "White Zircon",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-10.jpg?alt=media",
  },
  {
    id: 11,
    name: "Pink Sapphire, Blue Sapphire, Zircon",
    price: 580,
    size: 7.5,
    specifications: [
      "Padparadscha .48ct ",
      "Blue Sapphire .12ct ",
      "White zircon",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-11.jpg?alt=media",
  },
  {
    id: 12,
    name: "Natural Star Sapphire",
    price: 1220,
    size: 6,
    specifications: [
      "African Natural Star Sapphire",
      "Comment: HT(Pb)",
      "Cut: Very good",
      "Blue Sapphire",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-12.jpg?alt=media",
  },
  {
    id: 13,
    name: "Natural Burmese Ruby",
    price: 1180,
    size: 7,
    specifications: ["Burmese Natural Star Ruby", "White Zircon", "Gold 18KGP"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-13.jpg?alt=media",
  },
  {
    id: 14,
    name: "Siamese Ruby, Zircon",
    price: 880,
    size: 6.5,
    specifications: ["Siamese Ruby .80ct", "White zircon", "Gold 18KGP"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-14.jpg?alt=media",
  },
  {
    id: 15,
    name: "Yallow Sapphire, Zircon",
    price: 690,
    size: 7,
    specifications: [
      "Bangkacha Yellow Sapphire 1.36ct",
      "White zircon",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-15.jpg?alt=media",
  },
  {
    id: 16,
    name: "Amethyst",
    price: 350,
    size: 5.5,
    specifications: ["Amethyst", "Silver 925 Pink Gold Plating"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-16.jpg?alt=media",
  },
  {
    id: 17,
    name: "Yellow Sapphire, Emerald, Zircon",
    price: 880,
    size: 8.5,
    specifications: [
      "Bang Kacha Yellow Sapphire 1.01ct",
      "Comment: HT(Be)",
      "Emerald .47ct",
      "White Zircon",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-17.jpg?alt=media",
  },
  {
    id: 18,
    name: "Unheated Natural Star Ruby",
    price: 1850,
    size: 8,
    specifications: [
      "Unheated Burmese Natural Star Ruby",
      "Comment: No Indication Of Heat",
      "Cut: Very Good",
      "Bang Kacha Yellow Sapphire",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-18.jpg?alt=media",
  },
  {
    id: 19,
    name: "Natural Royal Blue Sapphire",
    price: 750,
    size: 7.5,
    specifications: [
      "Srilankan Royal Blue Sapphire",
      "Comment: HT",
      "Cut: Very Good ",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-19.jpg?alt=media",
  },
  {
    id: 20,
    name: "Green Sapphire, Orange Sapphire, Zircon",
    price: 880,
    size: 5.5,
    specifications: [
      "Bang Kacha Green Sapphire .82ct",
      "Songea Ruby .58ct",
      "White zircon",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-20.jpg?alt=media",
  },
  {
    id: 21,
    name: "London Blue Topaz",
    price: 380,
    size: 8,
    specifications: ["London Blue Topaz", "Silver 925"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-21.jpg?alt=media",
  },
  {
    id: 22,
    name: "Blue Sapphire, Red Songea Sapphire, Yellow Sapphire",
    price: 650,
    size: 8.25,
    specifications: [
      "Songea Ruby",
      "Songea Blue Sapphire",
      "Yellow Sapphire",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-22.jpg?alt=media",
  },
  {
    id: 23,
    name: "9 Lucky Gems",
    price: 650,
    size: 8.25,
    specifications: [
      "9 lucky gems 1.85ct Ruby (Sun), Pearl (Moon), Red Coral (Mars), Emerald (Mercury), Yellow Sapphire (Jupiter), Diamond (Venus), Blue Sapphire (Saturn), Hessonite (Rahu), and Cat's Eye (Ketu)",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-23.jpg?alt=media",
  },
  {
    id: 24,
    name: "9 Lucky Gems",
    price: 550,
    size: 7.5,
    specifications: [
      "9 lucky gems 1.85ct Ruby (Sun), Pearl (Moon), Red Coral (Mars), Emerald (Mercury), Yellow Sapphire (Jupiter), Diamond (Venus), Blue Sapphire (Saturn), Hessonite (Rahu), and Cat's Eye (Ketu)",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-24.jpg?alt=media",
  },
  {
    id: 25,
    name: "Natural Star Ruby",
    price: 880,
    size: 8.5,
    specifications: [
      "Burmese Natural Star Ruby",
      "Comment: HT(Pb)",
      "Cut: Very Good",
      "White Zircon",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-25.jpg?alt=media",
  },
  {
    id: 26,
    name: "Natural Sapphire, Yellow Sapphire",
    price: 1050,
    size: 7,
    specifications: [
      "Unheated Madagascan Blue Sapphire 1.68ct",
      "Comment: No Indication of Heat",
      "Cut: Very Good",
      "Bang Kacha Yellow Sapphire 2.18ct",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-26.jpg?alt=media",
  },
  {
    id: 27,
    name: "Green Sapphire, Red Songea Sapphire",
    price: 680,
    size: 7.5,
    specifications: [
      "Bang Kacha Green Sapphire .81ct",
      "Songea Ruby .61ct",
      "Green Sapphire",
      "Gold 18KGP",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-27.jpg?alt=media",
  },
  {
    id: 28,
    name: "Natural Star Ruby",
    price: 990,
    size: 7.5,
    specifications: [
      "Burmese Natural Star Ruby",
      "Comment: HT (Pb)",
      "Cut: Very Good",
      "White Zircon",
      "Silver 925",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-28.jpg?alt=media",
  },
  {
    id: 29,
    name: "Green Sapphire, Purple Sapphire, Pink Sapphire, Songea Sapphire, Zircon",
    price: 1100,
    size: 8,
    specifications: [
      "Green Sapphire 1.46ct",
      "Purple Sapphire .41ct",
      "Pink Sapphire .27ct ",
      "Songea Ruby .34ct",
      "White zircon",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-29.jpg?alt=media",
  },
  {
    id: 30,
    name: "Natural Zambia Emerald",
    price: 620,
    size: 6,
    specifications: [
      "Zambian Natural Emerald",
      "Shape: Round Cabochon",
      "Comment: CEE(O) Minor",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-30.jpg?alt=media",
  },
  {
    id: 31,
    name: "Citrine",
    price: 380,
    size: 6.5,
    specifications: ["Citrine", "Silver 925"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-31.jpg?alt=media",
  },
  {
    id: 32,
    name: "Sapphire",
    price: 650,
    size: 7.5,
    specifications: ["Blue Sapphire .85ct", "White zircon", "Silver 925"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-32.jpg?alt=media",
  },
  {
    id: 33,
    name: "Zircon",
    price: 380,
    size: 7,
    specifications: ["Zircon", "Silver 925"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-33.jpg?alt=media",
  },
  {
    id: 34,
    name: "Natural Star Ruby",
    price: 1220,
    size: 6.5,
    specifications: [
      "Burmese Natural Star Ruby",
      "Comment: HT(Pb)",
      "Cut: Very Good",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-34.jpg?alt=media",
  },
  {
    id: 35,
    name: "Sky Blue Topaz",
    price: 420,
    size: 7,
    specifications: ["Sky Blue Topaz", "Silver 925"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-35.jpg?alt=media",
  },
  {
    id: 36,
    name: "Swiss Blue Topaz",
    price: 320,
    size: 7,
    specifications: ["Swiss Blue Topaz", "Silver 925"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-36.jpg?alt=media",
  },
  {
    id: 37,
    name: "Natural Vivid Red Ruby",
    price: 1250,
    size: 5,
    specifications: [
      "Natural African Ruby",
      "Comment: HT(Pb)",
      "Cut: Very Good",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-37.jpg?alt=media",
  },
  {
    id: 38,
    name: "Natural Brazil Topaz / Africa Ruby",
    price: 1100,
    size: 7,
    specifications: [
      "Brazillian Natural Swiss Blue Topaz",
      "African Natural Ruby",
      "Comment: HT (Pb)",
      "White Zircon",
      "Gold 18KGP",
      "Certified*",
    ],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-38.jpg?alt=media",
  },
];
